import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { updateUserLocally } from "../../store/doctors/slice";

//imported
import { CLEARGY, DOCTOR } from "common/viewContent";
import * as Path from "routes/Path/index";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import PatientColumns from "../../components/MeetingHistory/PatientColumns";
import inputFields from "./inputFields";
import { Link, useNavigate } from "react-router-dom";
import {
  CountryCode,
  DoctorEdit,
  DoctorDel,
  getDoctorList,
  getDoctorListFiltered,
} from "store/actions";
import EditDoctor from "components/Modals/EditDoctorModal";
import countryList from "react-select-country-list";
import FormikForm from "components/shared/FormikForm";
import ConfirmModal from "components/Modals/ConfirmModal";
import EditPriest from "components/Modals/EditPriest/EditPriest";
const InputFieldsForSearch = [
  {
    name: "search_text",
    type: "text",
    placeholder: "Search using name,email...",
  },
];
const initialValuesForFilter = {
  search_text: "",
};
const ClergyList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const options = countryList().getData();
  const [editData, setEditData] = useState();
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const { USER, loading, totalCount } = useSelector((state) => state.Doctor);
  const [filtereddoctorsData, setfiltereddoctorsData] = useState([]);
  console.log(filtereddoctorsData, "filtereddoctorsData123");

  const [doctor, setDoctor] = useState();
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [editModalShow, setEditModalShow] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [search_text, setSearch_text] = useState();
  const [countryListData, setCountryListData] = useState();
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
    search_text: "",
  });
  const [formData, setFormData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    country: "",
    state: "",
    email: "",
    phone_no: "",
    country_code: "",
    city: "",
    license_no: "",
  });

  console.log("USER", USER);

  const onCliclNavigate = (id) => {
    navigate(`/admin/feedback/${id}`);
  };
  const fetchData = async (filter) => {
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      user_role: "4",
    };
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setDoctor(res);
        }
      };
      dispatch(getDoctorList({ data: payload, callback }));
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const fetchCountryData = async () => {
    let data = {};
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          setCountryListData(res.data);
        }
      };
      dispatch(
        CountryCode({
          data: data,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  useEffect(() => {
    const CountryList = options?.map((item) => {
      return { value: item?.label, label: item?.label };
    });
    inputFields.find((field) => field.type === "select").options =
      CountryList || [];
    const CountryCodeArray = countryListData?.map((obj) => {
      return { value: obj.calling_code, label: obj.calling_code };
    });
    inputFields.find((field) => field.type === "dynamic_select").options =
      CountryCodeArray || [];
  }, [countryListData, options]);
  useEffect(() => {
    fetchData(filter);
    fetchCountryData();
    setcolumns(
      Columns({
        onCliclNavigate,
        handleViewUser,
        handleEdithandler,
        deleteHandler,
        currentPage: filter?.pageNo,
        pageSize,
        handleUserStatus,
        handleUserOnlineStatus,
      })
    );
  }, [filter]);
  const handleEdithandler = (info) => {
    setFormData({ ...formData, ...info });
    setEditData(info);
    setEditModalShow(true);
  };
  const handleEditSub = (info) => {
    try {
      let data = {
        user_id: info.id,
        first_name: info.first_name,
        middle_name: info.middle_name,
        last_name: info.last_name,
        country: info.country,
        state: info.state,
        email: info.email,
        phone_no: info.phone_no,
        country_code: info?.country_code,
        city: info.city,
        license_no: info.license_no,
      };
      const callback = (err, res) => {
        if (err) {
          // console.log("test",err);
          toast.error(err.toString());
        } else {
          setEditModalShow(false);
          fetchData(filter);
          toast.success("User updated successfully!");
        }
      };
      dispatch(
        DoctorEdit({
          data: data,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleUserStatus = (row, status) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData(filter);
          toast.success("Status Changed");
        }
      };

      dispatch(
        DoctorEdit({
          data: { user_id: row?.id, status: status },
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const handleUserOnlineStatus = (row, status) => {
    try {
      const callback = (err, res) => {
        if (err) {
          toast.error(err);
        } else {
          fetchData(filter);
          toast.success("Online Status Changed");
        }
      };

      dispatch(
        DoctorEdit({
          data: { user_id: row?.id, is_priest_verified: status },
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  const deleteHandler = (id) => {
    setConfirmModal(true);
    setDeleteId(id);
  };
  const handleDeleteConfirm = (event) => {
    event.preventDefault();
    const callback = (err, res) => {
      console.log("error-->", err);
      if (err) {
        toast.error(err);
      } else {
        console.log("response-->", res);
        toast.success(res.message);
        fetchData(filter);
      }
    };
    dispatch(
      DoctorDel({
        data: { user_id: deleteId, is_deleted: "1" },
        callback,
      })
    );
    setConfirmModal(false);
    setDeleteId(null);
  };
  const onClickFilter = (e) => {
    e?.preventDefault();
    setFilter({
      ...filter,
      pageNo: 1,
      limit: pageSize,
      search_text: search_text,
    });
  };

  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      pageNo: 1,
      search_text: "",
    }));
    setSearch_text("");
  };

  const handleTableChange = (pageNumber, newPageSize) => {
    setCurrentPage(pageNumber);
  };
  const handleViewUser = (row) => {
    navigate(`${row.id}`, { state: { row } });
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <>
      {confirmModal && (
        <ConfirmModal
          show={confirmModal}
          handleClose={() => setConfirmModal(false)}
          title={"Confirmation"}
          content={"Are you sure you want to delete User"}
          handleConfirm={handleDeleteConfirm}
          loading={""}
        />
      )}
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {editModalShow && (
        <EditPriest
          show={editModalShow}
          handleClose={() => {
            setEditModalShow(false);
          }}
          title={"Edit Priest"}
          content={""}
          handleConfirm={handleEditSub}
          loading={loading}
          initialValues={formData}
          editData={editData}
        />
      )}
      <Helmet title={CLEARGY.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <h1>{CLEARGY.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{CLEARGY.CURRENT_MODULE} </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{CLEARGY.TOP_CONTENT}</h2>
                </div>
              </div>
              <div className="col-12">
                <form onSubmit={onClickFilter}>
                  <div className="card-header">
                    <div className="col-lg-4 col-sm-12 col-md-12 my-2 px-0">
                      <input
                        className="form-control"
                        name="search_text"
                        onChange={(e) => setSearch_text(e.target.value)}
                        value={search_text}
                        placeholder="Search using name, email..."
                      />
                    </div>
                  </div>
                  <div className="col-12 my-2 gap-4 ">
                    <div className="d-flex gap-4">
                      <button type="submit" className="btn btn-primary btn-lg">
                        Search
                      </button>
                      <button
                        onClick={() => clearFilter()}
                        type="button"
                        className="btn btn-primary btn-lg"
                      >
                        Clear Search
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {!loading && USER?.users?.length > 0 && (
            <Table
              data={USER?.users}
              columns={columns}
              setFilter={setFilter}
              handleTableChange={handleTableChange}
              totalCount={totalCount}
              filter={filter}
            />
          )}

          {USER?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Doctor Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default ClergyList;
